import { render, staticRenderFns } from "./addContactPerson.vue?vue&type=template&id=2b488d2c&scoped=true&"
import script from "./addContactPerson.vue?vue&type=script&lang=js&"
export * from "./addContactPerson.vue?vue&type=script&lang=js&"
import style0 from "./addContactPerson.vue?vue&type=style&index=0&id=2b488d2c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b488d2c",
  null
  
)

export default component.exports